<template lang="pug">
  .container
    ModalReveal(ref="modalOperation" :key="key" @input="closeInput")
      div.text-right(slot="trigger")
        a.fa-stack.fa-lg
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          select(v-model="preset", @change="usePreset($event)")
            option(selected, disabled, value="") Use preset...
            option(v-for="(i,k) in presets" :key="k" :value="k") {{ k }}: {{ i.description}}
      .row
        .column
          textarea(v-model = 'jsonOperation' rows=10 placeholder='Paste your Json Operation' style="font-family: monospace;")
      .row
        .column
        .input-group
          input.input-group-field(type='file', ref="file")
          .input-group-button
            .button(type='submit', :disabled="disabled || spin", @click="handleFile", value="Upload")
              span.fa.fa-spinner.fa-spin(v-if="spin", :class="{spin:spin}")
              span(v-else) Upload
      .row
        .column
          ActionButton(:action="doOperation" :disabled="jsonOperation==''") Run

    .component-backoffice-cargo-list.row.column
      base-list(:component="component", :dataLoader="dataLoader" ref="list")

</template>
<script type="text/babel">
//.column(v-if="viewUrl")
//input(type="text" id="myInput" :value="url")
//@change="changeContent"
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import ModalReveal from "../../components/structure/foundation/ModalReveal";
import MaggieHelper from "../../maggieHelper";
import BaseList from "./BaseList";
import KeplerFileUpload from "../../components/structure/KeplerFileUpload";
import ActionButton from "../../components/structure/ui/ActionButton";
import SelectionList from "../../components/structure/SelectionList";

export default {
  name: "Cargo",
  components: {
    SelectionList,
    ActionButton,
    KeplerFileUpload,
    BaseList,
    ModalReveal

  },
  data() {
    return {
      component: require('src/components/backoffice/Cargo'),

      jsonOperation: "",
      dataList: '',
      attachmentToken: null,
      jsonError: false,
      voidContent: false,
      spin: false,
      disabled: false,
      key: 0,

      preset: "",

      presets: {
        "import_fuel_codes": {
          "description": "Import fuel codes",
          "cargo": {
            "operation": "import",
            "payload": {
              "is_sync": false,
              "import": {
                "type": "fuel_codes",
                "attachment_token": "@attachment_token:#attachment_token#@"
              }
            },
          }
        },
        "fuel_codes_export": {
          "description": "Get all fuel_codes usage data",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "fuel_codes"
              }
            }
          }
        },
        "erogate_cashback_activity": {
          "description": "Erogate cashback for period",
          "cargo": {
            "operation": "activity",
            "payload": {
              "is_sync": false,
              "activity": {
                "type": "cashback",
                "params": {
                  "dry": false,
                  "month": "@CASHBACK-MONTH:#DATE_MONTH#@",
                  "reason": "@CASHBACK-REASON:CASHBACK_#DATE_MONTH#@",
                  "amount_remap": [
                    {
                      "min": 100,
                      "to": 10
                    },
                    {
                      "min": 60,
                      "to": 5
                    },
                    {
                      "min": 30,
                      "to": 2
                    }
                  ]
                }
              }
            }
          },
        },
        "perform_book_planning_activity": {
          "description": "Book a specific vehicle for a period",
          "cargo": {
            "operation": "activity",
            "payload": {
              "is_sync": false,
              "activity": {
                "type": "book_planning",
                "params": {
                  "driver_id": 1,
                  "plate": "@VEHICLE-PLATE:T787959C@",
                  "plan_id": "@PLAN-ID:9@",
                  "week_planning": [
                    "#c2c2c2 MON|SAT 09:00 12:00"
                  ],
                  "contract_duration": "@CONTRACT-DURATION:30@",
                  "start_date": "@START-DATE:#START_DATE#@"
                }
              }
            }
          }
        },
        "bonus_export": {
          "description": "Get all bonus usage data",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "bonus",
                "params": {
                  "bonus_name": "@BONUS-NAME@",
                  "type": "@TYPE:USE@"
                }
              }
            }
          }
        },
        "invoices_export": {
          "description": "Get all invoices data inclusive of sdi status",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "invoices",
                "params": {}
              }
            }
          }
        },
        "invoices_not_paid_export": {
          "description": "Get all invoices data inclusive of sdi status",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "invoices_not_paid",
                "params": {}
              }
            }
          }
        },
        "transactions_export": {
          "description": "Get transactions data inclusive of uid",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "transations",
                "params": {}
              }
            }
          }
        },
        "coupons_export": {
          "description": "Get used coupons and its users",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "coupons",
                "params": {
                  "common_cost_id": "@COMMON_COST_ID:49@"
                }
              }
            }
          }
        },
        "clients_export": {
          "description": "All clients in given periods",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "clients",
                "params": {}
              }
            }
          }
        },
        "clients_with_status_export": {
          "description": "All clients in given periods having a specific status|statuses comma separated",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "clients",
                "params": {
                  "status": "@STATUS:ACTIVE@"
                }
              }
            }
          }
        },
        "mail_chimp_drivers_export": {
          "description": "Driver with a particular status|statuses and|or client type can be extracted by configuring status and client_type.",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "type": "mail_chimp_drivers",
                "params": {
                  "status": "@STATUS:ACTIVE@",
                  "client_type": "@CLIENT_TYPE:PRIVATE@"
                }
              }
            }
          }
        },
        "drivers_export": {
          "description": "Get only basic info or tocs accepted info and|or plan subscribed by configuring 'tocs_id' and|or plan_id params",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "drivers",
                "params": {
                  "toc_id": "@TOCS_ID:13@",
                  "plan_id": "@PLAN_ID:29@"
                }
              }
            }
          }
        },
        "driver_reservation_requests_export": {
          "description": "Get driver booking request info, like booking_request_received_date_time, booking_request_status, booking_request_from_user",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "driver_reservation_requests",
                "params": {}
              }
            }
          }
        },
        "reservation_simple_export": {
          "description": "Get basic reservation info",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "reservations_simple",
                "params": {}
              }
            }
          }
        },
        "reservation_export": {
          "description": "Get complete reservation info like detailed cost,plan related,travel info and more",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "reservations",
                "params": {}
              }
            }
          }
        },
        "reservation_filtered_export": {
          "description": "Get complete reservation info. Reservations can be also filtered by setting (all,one or some) parameters",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "reservations",
                "params": {
                  "id": "@ID:0@",
                  "status": "@STATUS:ACTIVE@",
                  "billing_status": "@BILLING_STATUS:CHARGED@",
                  "booking_mode": "@BOOKING_MODE:FF@",
                  "maintenance": "@MAINTENANCE:true@",
                  "flag": "@FLAG@",
                  "vehicle_plate": "@VEHICLE_PLATE:PC12345@",
                  "vehicle_type": "@VEHICLE_TYPE:car@",
                  "vehicle_slot_id": "@VEHICLE_SLOT_ID:0@",
                  "driver_id": "@DRIVER_ID:0@"
                }
              }
            }
          }
        },
        "vehicles_export": {
          "description": "Get basic reservation info",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "vehicles",
                "params": {}
              }
            }
          }
        },
        "vehicles_archived_export": {
          "description": "Get basic reservation info. Get archived vehicle by setting 'archived' params",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "vehicles",
                "params": {
                  "archived": "archived"
                }
              }
            }
          }
        },
        "vehicle_slot_periods_export": {
          "description": "Get info about status enabled duration in minutes",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "vehicles_slot_periods",
                "params": {}
              }
            }
          }
        },
        "vehicle_position_log_export": {
          "description": "Get info about vehicle position with reverse geocode",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {

                "type": "vehicle_position_log",
                "params": {
                  "plate": "@VEHICLE-PLATE:@",
                  "start": "@START_DATE:@",
                  "end": "@END_DATE:@",
                }
              }
            }
          }
        },
        "vehicles_reservations_export": {
          "description": "Get vehicle reserved_charged_time_hours and vehicle trip_charged_time_hours in period",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "vehicles_reservations",
                "params": {}
              }
            }
          }
        },
        "vehicle_charging_time_export": {
          "description": "Get info about pre-charge and post-charge level, duration recharge and when vehicle has been recharged",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start": "@START_DATE:#START_DATE#@",
                "end": "@END_DATE:#END_DATE#@",
                "type": "vehicle_charging_time",
                "params": {
                  "vehicle_type": "@VEHICLE_TYPE:car@",
                  "parking_group_name": "@PARKING_GROUP_NAME:MAINTENANCE@"
                }
              }
            }
          }
        },
        "reporting_export": {
          "description": "Get reporting list in period. Reporting can be also filtered by setting status",
          "cargo": {
            "operation": "export",
            "payload": {
              "is_sync": false,
              "export": {
                "start":"@START_DATE:#START_DATE#@",
                "end":"@END_DATE:#END_DATE#@",
                "type": "reporting",
                "params": {
                  "status": "@STATUS:PENDING_REVIEW@",
                }
              }
            }
          }
        },
        "perform_reservation_report_activity": {
          "description": "Reservation report with driver data document",
          "cargo": {
            "operation": "activity",
            "payload": {
              "is_sync": false,
              "activity": {
                "type": "reservation_report",
                "params": {
                  "text": "<p>Insert text you want</p>",
                  "recipient_info": ["Insert info"],
                  "document_info": [
                    {
                      "title": "ID",
                      "value": "reservation id"
                    }
                  ],
                  "header_info": [
                    {
                      "title": "Insert a title",
                      "value": "Insert text"
                    }
                  ],
                  "prev_next_reservations": 0
                }
              }
            }
          }
        },
      }
    }
  },
  watch: {

    jsonOperation: function (newValue) {
      this.jsonOperation = newValue
    },

  },
  mounted() {
    this.dataLoader()
    this.preset = ""
  },
  methods: {
    usePreset(event) {
      var tmpContent = JSON.stringify(this.presets[this.preset].cargo, null, 2)

      //match #variables#
      let matches = tmpContent.match(/#[A-Za-z0-9-_:#]+#/g)

      const today = new Date(), year = today.getFullYear(), tempMonth = today.getMonth() + 1
      const lastDayTemp = new Date(year, tempMonth, 0);
      const month = tempMonth < 10 && tempMonth > 0 ? "0" + tempMonth : tempMonth;

      const yearMonth = year + "-" + month;
      const firstDay = yearMonth + "-" + "01";
      const lastDay = yearMonth + "-" + lastDayTemp.getDate();

      if (matches) {
        matches.forEach((r) => {
          let v;
          switch (r) {
            case "#START_DATE#":
              v = firstDay;
              break;
            case "#END_DATE#":
              v = lastDay;
              break;
            case "#DATE_MONTH#":
              v = yearMonth;
              break;
            default:
              v = "undefined";
          }
          tmpContent = tmpContent.replace(r, v)
        })
      }

      //match @variables@
      matches = tmpContent.match(/@[A-Za-z0-9-_:#]+@/g)

      if (matches) {
        matches.forEach((r) => {
          let r2 = r.replaceAll("@", "")
          let sp = r2.split(":")
          let v = prompt("VALUE FOR " + sp[0] + "?", sp[1])
          tmpContent = tmpContent.replace(r, v)
        })
      }
      this.jsonOperation = tmpContent
    },
    changeContent(event) {
      console.log(event.target.value)
      if (!this.isJson(event.target.value)) {
        MaggieHelper.notification('Operation esit', 'Insert json text', 'alert')
        this.jsonError = false
      } else {
        this.jsonError = true
      }

    },
    closeInput(event) {
      if (!event) {
        this.jsonOperation = ''
        this.attachmentToken = ''
        this.key++
      }
    },
    doOperation() {
      if (!this.isJson(this.jsonOperation)) {
        MaggieHelper.notification('Operation esit', 'Insert json text', 'alert')
        this.operationError = true
        return Promise.resolve()
      }
      return KeplerBackofficeSdk.cargo.cargoOperationCreate(JSON.parse(this.jsonOperation), (data) => {
        this.$refs.list.loadData(1)
        this.jsonOperation = ''
        this.attachmentToken = ''
        this.key++
        this.$refs.modalOperation.close()

        var p = Object.entries(data)
        MaggieHelper.notification('Operation id', p[0], 'success')
      })

    },


    dataLoader(callback, page, resultsPerPage) {
      return KeplerBackofficeSdk.cargo.operationList(1, 25, data => {
        callback(data)
      })
    },
    handleFile(path) {
      this.spin = true
      if (!this.isJson(this.jsonOperation)) {
        // MaggieHelper.notification('Operation', 'Insert json text', 'alert')
        this.jsonOperation = JSON.stringify({})
        this.voidContent = true
      }
      var self = this
      var file = this.$refs.file.files[0]

      KeplerBackofficeSdk.cargo.import(file, data => {
        self.response = data
        MaggieHelper.notification('upload', 'File uploaded successfully')
        this.spin = false
        var jsonObj = JSON.parse(self.jsonOperation)

        if (Object.keys(jsonObj).length === 0 || self.voidContent) {

          jsonObj = {
            "operation": "import",
            "payload": {
              "import": {
                "attachment_token": "",
              }
            }
          }

        }
        jsonObj.payload.import.attachment_token = self.response.token
        self.jsonOperation = JSON.stringify(jsonObj)
        self.voidContent = false
      })
    },
    isJson(str) {
      try {
        const obj = JSON.parse(str);
        if (obj && typeof obj === `object`) {
          return true;
        }
      } catch (err) {
        return false;
      }
      return false;
    }

  },
  computed: {},
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Cargo.vue?690c841e